export default __webpack_public_path__ + "static/media/services_03.5068e1ac.jpg";